// extracted by mini-css-extract-plugin
export var boxItems = "_5r-1";
export var boxItemsLg = "_5r-2";
export var button = "_5r-7";
export var buttonLg = "_5r-8";
export var filterGroupBox = "_5r-0";
export var icon = "_5r-3";
export var iconSecondary = "_5r-6";
export var iconWrapper = "_5r-4";
export var iconWrapperLg = "_5r-5";